---
en:
  activerecord:
    attributes:
      api/key:
        company_ids: Company access
        description: Description
        name: Name
        token: Token
      asset_comment:
        content: Message
        period: Period
        periods:
          monthly: Monthly
          quarterly: Quarterly
          yearly: Yearly
        power_plant_id: Power plant
      bilateral_data:
        kaia_trade_metric_name: Kaia Trade metric name
        ownership_share: Ownership share
      budget_forecast:
        avg_price: Average price
        price_area: Price area
        volume_percent: Volume percent
      company:
        availability_analysis_enabled: Availability analysis enabled
        benchmarking: Benchmarking enabled
        business_id: Business ID
        commercial_scada_enabled: Commercial SCADA enabled
        detect_water_loss_downtime_enabled: Detect water loss downtime enabled
        environmental_flow_tracking_enabled: Environmental flow tracking enabled
        follow_up_enabled: Follow up enabled
        liquidity_planning_enabled: Liquidity Planning enabled
        market_outlook_enabled: Market outlook enabled
        om_dashboard_enabled: O&M Dashboard enabled
        ppa_pricing_enabled: PPA Pricing enabled
        remove_logo: Remove logo
        task_management_enabled: Task management enabled
        url_facebook: Facebook
        url_homepage: Homepage
        url_instagram: Instagram
        url_linked_in: LinkedIn
        white_labeling: White labeling enabled
      company_responsible:
        power_plants: Power plants
        responsible: Responsible
      contract:
        active: Active
        counterpart: Counterpart
        end_date: Contract end date
        open_ended: Open-ended contract
        power_plant: Power plant
        power_plants: Power plants
        start_date: Contract start date
        type: Contract type
      downtime_event:
        comment: Comment
        component: Main Component
        ends_at: Period end
        insurance: Insurance claim
        power_plant_id: Power plant
        reason: Reason
        starts_at: Period start
        total: Total
        verified: Verified
        volume: Volume
        volume_hint: Average unavailable capacity per hour
        volume_set_manually: Set volume manually
        volume_should_have_been: Average expected volume per hour in the time period
      event:
        active: active
        alarm_categories: Alarm categories
        component: Component
        duration: Duration
        ends_at: To
        energy_loss_mwh: Energy loss (MWh)
        operational_status: Operational status
        starts_at: From
        unavailable_power_kw: Unavailable power (kW)
        yield_loss: Yield loss (%{currency})
      fall_lease:
        amount: Amount
        code: Code
        description: Description
        month: Month
        owner: Owner
        period: Period
        year: Year
      feature_request:
        author: Author
        category: Category
        date: Date
        status: Status
        title: Title
        upvotes: Upvotes
      feed_in_tariff_data:
        limit_type: Limit type
        limit_types:
          fixed_price: Fixed price
          price: Price
        limit_value: Limit value
      hedging_data:
        limit_type: Limit type
        limit_types:
          percent: Percent
          volume: Volume
        limit_value: Limit value
        price: Price
        strategies:
          monthly: Monthly
          pay_as_produced: Pay as Produced
          quarterly: Quarterly
          yearly: Yearly
        strategy: Strategy
      hydro/asset:
        bypass_valve: Bypass valve
        concession_date: Concession date
        pipe_rupture_valve: Pipe rupture valve
        river_name: River
        start_stop_power_fraction: Start/stop power fraction
        start_stop_power_fraction_hint: Power change as a fraction of rated power within 15 min that marks a turbine start/stop
        winter_closed: Winter closed
      hydro/environmental_flow_breakpoints:
        day: Day
        flow: Flow
      hydro/generator:
        effect_limitation: External limitation
        efficiency_percent: Efficiency
        installed_capacity_mva: Capacity [MVA]
        power_factor_percent: Power factor
      hydro/intake:
        dam_length: Dam length [m]
        dam_width_streamwise: Dam width [m]
        intake_type: Intake type
        lat: Latitude
        lng: Longitude
        lower_alert_limit: Lower alert limit
        masl: Intake masl
        trash_rack_cleaner: Trash rack cleaner
        upper_alert_limit: Upper alert limit
        upstream_depth: Upstream depth [m]
      hydro/model_param:
        bypass_max: Bypass max
        bypass_min: Bypass min
        continuous_dispatch: Continuous dispatch
        discharge_max: Discharge max
        discharge_min: Discharge min
        energy_deviation_threshold: Energy deviation threshold
        energy_equivalent: Energy equivalent
        net_head_masl_bound_max: Net head bound max (masl)
        net_head_masl_bound_min: Net head bound min (masl)
        overflow_protection: Overflow protection
        p_max_overflow: Max production at overflow
        production_max: Production max
        production_min: Production min
        production_min_runtime_hours: Minimum-load runtime
        production_sensitivity_max: Production sensitivity max
        production_sensitivity_min: Production sensitivity min
        resample_to: Resample to
        reservoir_max_masl: Reservoir max (masl)
        reservoir_min_masl: Reservoir min (masl)
        reservoir_target_percentage: Reservoir target
        runoff_scale_factor: Runoff scale factor
        startup_override_production: Startup override production
        use_runoff_data: Use runoff data
      hydro/penstock:
        diameter: Diameter
        length: Length
        material: Material
        net_head_loss_percent: Net head loss
        risk_category: Risk category
      hydro/precipitation_field:
        aborigines: Indigenous people
        area: Area
        avg_flow_area: Average area flow
        field_length: Field length
        forest_size_percent: Forest size
        glacier_size_percent: Glacier size
        lat: Latitude
        lng: Longitude
        mountain_size_percent: Mountain size
        sea_size_percent: Sea size
        swamp_size_percent: Swamp size
      hydro/reservoir:
        artificial_reservoir: Artificial reservoir
        gross_dammed_area: Gross dammed area
        gross_power_density: Gross power density
        highest_reservoir_value: Highest reservoir value
        lat: Latitude
        lng: Longitude
        lowest_reservoir_value: Lowest reservoir value
        name: Name
        net_dammed_area: Net dammed area
        net_power_density: Net power density
        reservoir_name: Reservoir name
        reservoir_volume: Reservoir volume
        risk_category: Risk category
        surface_area: Surface area
      hydro/river:
        anadromous_fish: Anadromous fish
        name: Name
        river_gradient: River gradient
        river_length: River length
        watercourse: Watercourse
        watercourse_area: Watercourse area
      hydro/transformer:
        capacity_mva: Capacity [MVA]
        effect_limitation: Effect limitation
        efficiency_percent: Efficiency
      hydro/turbine:
        efficiency_percent: Efficiency (at nominal conditions)
        efficiency_percent_short: Efficiency
        installed_effect_mw: Capacity [MW]
        masl: Turbine masl
        max_throughput_operational: Max. op. throughput
        min_throughput_operational: Min. op. throughput
        q_min_loss_percent: Q min loss
        turbine_type: Turbine type
      label:
        color: Color
        name: Name
      news_item:
        accessible_by: Related to
        allow_comments: Allow comments
        author: Author
        body: Body
        category: Category
        community_access: Community post
        companies: Companies
        date: Date added
        image: Image
        image_position: Image position
        include_subsidiaries: Include subsidiaries
        internal_post_landowner_access: Landowner access
        portfolio_access: Portfolio
        posts:
          one: Post
          other: Posts
        power_plants: Power Plants
        title: Title
      nve_metadata:
        building_type: Building type
        building_types:
          surface: Surface
          surface_underground: Underground/Surface-based
          underground: Underground
        bypasswater_downstream_powerplant_label: Water bypass to downstream powerplant (NVE ref. nr)
        date_inital_utilization_of_waterfall: Date of initial utilization of waterfall
        date_oldest_power_producing_part: Date of oldest power producing part
        energy_equivalent: Energy equivalent [KWh/m^3]
        floodwater_downstream_powerplant_label: Floodwater to downstream powerplant (NVE ref. nr)
        min_throughput: Min. throughput
        min_throughput_unit: Min. throughput [m^3/sec]
        nve_bypasswater_downstream_powerplant: Water bypass to downstream powerplant
        nve_floodwater_downstream_powerplant: Floodwater to downstream powerplant
        nve_production_downstream_powerplant: Production to downstream powerplant
        powerplant_type: Powerplant type
        powerplant_types:
          reservoir: Reservoir power plant
          run_of_river: Run-of-river power plant
        precipitation_area: Precipitation Area
        production_downstream_powerplant_label: Production to downstream powerplant (NVE ref. nr)
        regine_nr: Regine nr
        sp_nr_point_reference: Sp nr pointer reference
        sp_nr_watercourse: Sp nr watercourse
      power_plant:
        absorption_capacity: Max. throughput
        asset_class: Asset class
        axpo_id: Axpo ID
        bazefield_site_id: Bazefield site ID
        biodiversity_sensitive_areas: Biodiversity sensitive areas
        climate_future_ref: Climate future ref
        co2_emission: CO2 emission
        collect_weather: Collect weather data
        commissioning_date: Commissioning Date
        company_id: Company
        company_name: Company name
        continuous_forecast_enabled: Continuous forecast enabled
        country_id: Country
        county: County
        county_name: County name
        datastream: Datastream
        day_ahead_forecast_enabled: Day ahead forecast enabled
        downtime_analysis: Downtime analysis
        ecs_id: ECS ID
        elcert: Elcert
        elcert_ends_on: Elcert end
        elcert_starts_on: Elcert start
        external_id: Nest ID
        forecast_query_enabled: Forecast Query enabled
        forecasted_budget: Forecasted budget
        generator_capacity_mva: Generator capacity [MVA]
        go_date: GO expiry date
        greenbyte_site_id: Greenbyte site ID
        grid_owner: Grid owner
        gurusoft_tags: Gurusoft tags
        image: Upload new image
        image_attribution: Image attribution
        in_operation: In operation
        intake_count: Intake count
        intake_lat_lng: Intake coordinates
        internal_notes: Internal notes
        kaia_uuid: Kaia UUID
        krasys_live_measurement_values: KRASYS live measurement values
        kwh_m3: Energy equivalent
        lat: Latitude
        lng: Longitude
        max_effect: Hist. max effect
        max_throughput_operational: Max. op. throughput
        metering_point_id: Metering Point ID
        min_operational_power: Min. operational power [MW]
        min_production_effect: Downtime threshold [MW]
        min_throughput_operational: Min. op. throughput
        model_parameters: Model parameters
        municipality: Municipality
        municipality_name: Municipality name
        name: Name
        net_head_masl: Plant net head
        nispera_id: Nispera ID
        num_segments: Number of segments
        nve_gwh: Annual production
        nve_nr: NVE-nr
        nve_status: Status
        optimization_model: Optimization model
        owner: Owner
        periods: Periods
        plant_effect_mw: Plant capacity [MW]
        postcode: Postcode
        price_area: Price area
        price_dependent_bid_override: Price dependent bid threshold
        production_simulation_plan_enabled: Production Simulation Plan enabled
        project: Project
        rated_power_mw: Rated power [MW]
        remove_image: Remove image
        reservoir: Reservoir
        scada_int_id: Scada International ID
        scada_int_tag: Scada International tag
        settled_volume_source: Settled volume source
        shadow_testing: Shadow testing
        shadow_tracking: Shadow tracking
        site_address: Site address
        station_lat_lng: Station coordinates
        statkraft_customer_id: Statkraft customer ID
        turbine_count: Turbine count
        turbine_level_masl: Turbine level masl
        turbine_type: Turbine type
        unsettled_volume_source: Unsettled volume source
        use_price_dependent_bid: Use price dependent bid?
        vertical_drop: Net head
        weather_source: Weather source
        wikipedia_page_id: Wikipedia article ID
        xledger_project_id: Xledger Project ID
        yearly_production: Normal production [GWh]
      power_plant_responsible:
        company_responsible: Responsible
        role_values:
          accounting: Accounting
          asset_manager: Asset Manager
          auditor: Auditor
          balancing_responsible: Balancing Responsible
          ceo: CEO
          guarantees_of_origin_sales: Guarantees of origin sales
          hv_leader: Electrical operators manager (HV Leader)
          insurance_broker: Insurance Broker
          internal_grid_om: Internal Grid O&M
          internet_provider: Internet Provider
          operator: O&M responsible
          owner_representative: Owner representative
          plant_supervisor: Plant supervisor
          road_maintenance: Road Maintenance
          snow_ploughing: Snow Ploughing
          substation_om: Substation O&M
          turbine_om: Turbine O&M
          vta: VTA
          waste_management: Waste Management
        roles: Roles
      responsible:
        email: Email
        name: Name
        phone: Phone
        user_id: User
      scheduled_downtime_event:
        comment: Comment
        component: Main Component
        curtailed_mode: Curtailed mode
        ends_at: Period end
        operator_email: Operator email
        power_plant_id: Power plant
        reason: Reason
        starts_at: Period start
        volume: Volume
        volume_hint: Average unavailable capacity per hour
      self_consumption_data:
        currency_code: Currency
        generator_auxiliary_consumption_price_mwh: Generator auxiliary consumption cost per MWh
        grid_injection_price_mwh: Grid injection price per MWh
        grid_injection_spot: Grid injection at spot price
        self_consumption_price_mwh: Self consumption price per MWh
      sensor:
        lower_alert_limit: Lower alert limit
        upper_alert_limit: Upper alert limit
      solar/asset:
        anomaly_thresholds_help: 'Keep default anomaly detection tuning parameters with <code>&#123;&quot;idc&quot;:null,&quot;udc&quot;:null,&quot;fuac&quot;:null,&quot;min_gpoa_availability_wm2&quot;:60.0&#125;</code>.<br /> Possible full customization with default settings:'
        anomaly_thresholds_raw: Anomaly thresholds
        avg_yearly_solar_radiation: Avg yearly solar radiation
        data_source_settings_help: 'Data source settings in json format. Mandatory attribute: <code>type</code> to define the data source.<br /> See <a href="https://github.com/kaia/captiva_portal/wiki/Solar-data-source-settings.">Kaia portal wiki</a> for additional settings.<br /> Example for Solar-Log FTP:'
        data_source_settings_raw: Data source settings
        full_operating_hours: Full operating hours
        ml_learning_parameters_help: 'Minimal settings without inverters or mppt replacements: <code>&#123;&quot;timestamp_from&quot;:&quot;2023-01-01T00:00:00Z&quot;,&quot;timestamp_to&quot;:&quot;2024-01-01T00:00:00Z&quot;,&quot;inv_replacements&quot;:[],&quot;mppt_replacements&quot;:[]&#125;</code>.<br /> Example with components replacements:'
        ml_learning_parameters_raw: ML learning parameters
        storage_unit_present: Battery storage system present
        substation_lat: Substation lat
        substation_lng: Substation lng
        substation_masl: Substation MASL
      solar/field:
        installed_power_kwp: Installed power
        module_efficiency_percent: Module efficiency
        mounting_mode: Mounting mode
        mounting_modes:
          freestanding: Free-standing (unrestricted air circulation)
          fully_insulated: Fully insulated backside
          intermediary: Intermediary (limited air circulation)
        name: Name
        orientation: Orientation
        tilt: Tilt
      solar/inverter:
        external_id: Mapping data source
        installed_power_kwp: Installed power
        modules_count: Module count
        name: Name
        signal_mapping_raw: Signal mapping
        solar_inverter_type_id: Solar inverter type
        valid_from: Valid from
        valid_to: Valid to
      solar/inverter_type:
        maximal_power_kva: Maximal apparent power
        model: Model
        mppt_count: Number of MPPTs
        nominal_power_kw: Nominal active power
        supplier: Manufacturer
        supplier_id: ID
      solar/model_param:
        production_max: Production max
        production_min: Production min
        production_sensitivity_max: Production sensitivity max
        production_sensitivity_min: Production sensitivity min
      solar/module_type:
        alpha_isc: Temperature Coefficient of ISC Alpha
        beta_uoc: Temperature Coefficient of Uoc Beta
        cell_type: Cell technology
        cells_in_series: Cells in Series
        current_impp_a: MPP Current
        current_isc_a: Short-circuit Current
        gamma_pmpp: Temperature Coefficient of Pmpp Gamma
        length_mm: Frame Length
        model: Model
        module_efficiency: Module efficiency
        noct_degc: Nominal Operating Cell Temperature NOCT
        power_pmpp_w: Nominal power
        supplier: Manufacturer
        supplier_id: ID
        system_voltage_v: Maximum System Voltage
        voltage_umpp_v: MPP Voltage
        voltage_uoc_v: Open-circuit Voltage
        width_mm: Frame Width
      solar/mppt:
        input_number: Input number
        installed_power_kwp: Installed power
        modules_efficiency: Modules efficiency
        modules_in_series: Modules in Series
        modules_surface_m2: Connected modules surface
        signal_mapping_raw: Signal mapping
        solar_field_id: Solar field
        solar_module_type_id: Solar module type
        source_name: Data source name
        stringbox_name: SCB name
        strings_in_parallel: Strings in Parallel
      spot_data:
        ownership_share: Ownership share
      supplier:
        add_new: Add new supplier
        category: Category
        type: Type
        url_facebook: Facebook
        url_homepage: Homepage
        url_instagram: Instagram
        url_linked_in: LinkedIn
      user:
        avatar: Avatar
        avatar_lowercase: avatar
        company_ids: Companies
        currency_code: Currency
        email: Email
        firstname: First name
        job_title: Job title
        lastname: Last name
        locale: Portal language
        news_email: Weekly news email
        password: Password
        password_confirmation: Confirm password
        phone: Phone
        power_plant_ids: Power plants
        short_bio: Short bio
      wind/asset:
        activity: Activity
        avg_yearly_wind_speed: Avg yearly wind speed
        data_source_settings_raw: Data source settings
        full_operating_hours: Full operating hours
        recycle_share_percent: Recycle share
        substation_lat: Substation lat
        substation_lng: Substation lng
        substation_masl: Substation MASL
      wind/availability_calculation:
        contractual_availability_calculation: Contractual availability calculation
        contractual_availability_energy_based: Contractual Availability
        energy_based_availability: Energy based availability
        time_based_availability: Time based availability
      wind/availability_mapping:
        alarm_category: Alarm category
        alarm_category_types:
          environmental: Environmental
          force_majeure: Force Majeure
          grid: Grid
          manufacturer: Manufacturer
          no_data: No data
          owner: Owner
          turbine_ok: Turbine OK
        contractual_availability: Contractual Availability
        mapping_types:
          neglected: Neglected
          ready: Ready
          unavailable: Unavailable
        total_availability: Total availability
      wind/availability_target:
        contractual_availability_target: Contractual availability target
        year: Year
      wind/event_mappings:
        alarm_category_type: Alarm category type
        turbine_event_code: Turbine event code
        turbine_event_name: Turbine event name
      wind/model_param:
        production_max: Production max
        production_min: Production min
        production_sensitivity_max: Production sensitivity max
        production_sensitivity_min: Production sensitivity min
      wind/power_curve:
        air_density_kgm3: Air Density [kg/m3]
        default: Default power curve
        file: File
        historical_power_curve: Historical power cuve
        manufacturer_power_curve: Manufacturer power curve
        name: Name
        power: Power
        power_kw: Power [kW]
        show: Show power curve
        title: Power Curves
        wind_speed: Wind speed
        wind_speed_ms: Wind speed [m/s]
      wind/turbine:
        commissioning_year: Commissioning year
        external_source_id: External source ID
        ground_altitude_masl: Ground altitude
        hub_height: Hub height
        lat: Latitude
        lng: Longitude
        name: Name
        tip_height: Tip height
        wind_turbine_type_id: Wind turbine type
      wind/turbine_type:
        meteomatics_id: Meteomatics turbine ID
        name: Name
        rated_power_kw: Rated power [kW]
        rotor_diameter: Rotor diameter [m]
        supplier_id: ID
      work_item:
        budget_cost: Budget cost
        closed_on: Closed on
        company_responsible: Responsible
        component: Component
        description: Description
        due_date: Due date
        elapsed_cost: Elapsed cost
        forecast_cost: Forecast cost
        id: ID
        labels: Labels
        last_comment: Last comment
        power_plant: Power plant
        started_on: Started on
        status: Status
        title: Title
        valuta: Currency
    errors:
      models:
        budget_forecast:
          volume_forecast: has to be between 0 and 100
        contract:
          too_long: Has to be only one power plant
        event:
          cannot_change_component_or_operation_status_settled: Cannot change component or operational_status_type_id for a settled unterminated event
          cannot_delete_settled: Cannot delete a settled event
          cannot_modify_locked_event: Cannot modify a locked event
          cannot_overlap: Overlapping events for the same component are not allowed
          cannot_update_settled: Cannot update a settled/terminated event
        market_paramaeter:
          bids_illogical: The minimum bid price cannot be greater than the maximum
    models:
      elcert_month:
        one: Elcert month
        other: Elcert months
      go_month:
        one: GoO month
        other: GoO months
